import { SET_COUPONS, SET_SPECIFIC_COUPON } from "../Types/CouponTypes";

const initialState = {
  coupons: [],
  specificCoupon: null,
};

const CouponReducer = (state = initialState, action) => {
  if (action.type === SET_COUPONS) {
    return { ...state, coupons: action.payLoad };
  } else if (action.type === SET_SPECIFIC_COUPON) {
    return { ...state, specificCoupon: action.payLoad };
  } else {
    return state;
  }
};

export default CouponReducer;
